import { WIS_RPC_COMMANDS, WIS_RPC_MESSAGE } from '../constants';

import executeWisRpc from './executeWisRpc';

export default function sendWisReady(socket) {
    const rpcCommand = {
        message: WIS_RPC_MESSAGE.WISERVICE,
        msgdata: {
            command: WIS_RPC_COMMANDS.READY
        }
    };

    executeWisRpc(socket, rpcCommand);
}
